export interface dtcListModel {
  dtc?: {
    _id?: string;
    dtc?: string;
    name?: string;
    description?: string;
    severity?: string;
  };
  time?: string;
  count?: number;
  sourceTimestamp?: string;
  segment?: string;
  dtcCode?: string;
  frequency?: number;
  dtcName?: string;
  dtcDescription?: string;
}